import React, { useEffect, useState } from 'react';
import axios from 'axios';

const TableYo = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://cacityofgod.pythonanywhere.com/citizen/get_yoruba_breakfastwiththeholyspirit/');
        setData(response.data);
      } catch (error) {
        console.error('Error fetching devotional data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-full bg-white shadow-md rounded-lg overflow-hidden">
      <table className="w-full">
        <thead className="bg-gray-100">
          <tr>
            <th className="py-2 px-4">Date</th>
            <th className="py-2 px-4">Title</th>
            <th className="py-2 px-4">Text</th>
            <th className="py-2 px-4">Content</th>
            <th className="py-2 px-4">Prayer</th>
            <th className="py-2 px-4">Bible Reading</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.date}>
              <td className="py-2 px-4">{item.date}</td>
              <td className="py-2 px-4">{item.title}</td>
              <td className="py-2 px-4">{item.text}</td>
              <td className="py-2 px-4">{item.content}</td>
              <td className="py-2 px-4">{item.prayer}</td>
              <td className="py-2 px-4">{item.bible_reading}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableYo;